import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { acceptPolicy, fetchCurrentPolicies } from './policies.api';

export const policyKeys = {
  current: ['policies', 'current'] as const,
};

/**
 * What this account is being asked to agree to.
 *
 * Long stale time on purpose: policy versions change a handful of times a year,
 * and this runs on every signed-in page to drive the acceptance banner.
 */
export function useCurrentPolicies(enabled = true) {
  return useQuery({
    queryKey: policyKeys.current,
    queryFn: fetchCurrentPolicies,
    enabled,
    staleTime: 10 * 60_000,
  });
}

export function useAcceptPolicy() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (policyId: string) => acceptPolicy(policyId),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: policyKeys.current }),
  });
}
